// extracted by mini-css-extract-plugin
module.exports = {"registerCard":"cms-card_registerCard__ofGt3","title":"cms-card_title__O7r8A"};